export const EMAIL = 'EMAIL';
export const ZENDESK = 'ZENDESK';
export const DESK = 'DESK';
export const INTERCOM = 'INTERCOM';

export const MULTI_INTENT = 'Multi-intent';
export const SINGLE_INTENT = 'Single-intent';

export const INTERNAL_NOTE = 'INTERNAL_NOTE';
